import {StringPatternSchema} from 'favorlogic-utils';

import {validationRegularExpressions} from 'utils/DairyValidator';

export const CustomerCodeSchema = StringPatternSchema(validationRegularExpressions.customerCode);

export type CustomerCode = string;
